import { render, staticRenderFns } from "./FormList.vue?vue&type=template&id=36c003f7"
import script from "./FormList.vue?vue&type=script&lang=js"
export * from "./FormList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports